import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		subformBuildingLimits_inputContainer: {
			display: 'flex',
			flexDirection: 'column',
			padding: theme.spacing(3, 0),
			[theme.breakpoints.up(BreakpointWidth.X_LARGE)]: {
				width: '400px',
			},
			[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
				flex: '1 0',
			},
		},
		subformBuildingLimits_coverageLimits: {

		},
		subformBuildingLimits_title: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
		},
	});
});

export default useStyles;
